import {View} from 'backbone';

import BaseControlView from 'BaseControlView.js';
import template from 'report/control-filter-selector.ejs';
import eventBus         from 'EventBus.js';
import constants        from "Constants.js";
import resizeController from 'ResizeController.js';

class FilterSelectorView extends BaseControlView {

    initialize( opts ) {

        super.initialize( opts );

        this.template = template;
        this.tagName = 'div';
        this.family = constants.CONTROL_COMMON_INPUTS;
        this.icon = '.pf-filter-selector';

        this.listenTo(this.model, 'change', this.render);
        this.listenTo( eventBus, 'InputThemeChange', this.themeChangeRender);

        return this;
    } 

    get kind() {
        return 'BaseStaticControl';
    } 
}

export default FilterSelectorView;
